import { DatePicker } from "@mui/x-date-pickers";
import { Label } from "components/input/Label";
import MultiSeletor from "components/multiSeletor/MultiSeletor";
import dayjs from "dayjs";
import { IndicadorColeta } from "model/indicadores/IndicadorColeta";
import IndicadorDashboard from "model/indicadores/IndicadorDashboard";
import IndicadorDashboardItem from "model/indicadores/IndicadorDashboardItem";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Tag } from "primereact/tag";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import IndicadorDashboardService from "service/indicadores/IndicadorDashboardService";
import IndicadorService from "service/indicadores/IndicadorService";
import { converterData } from "utils/convert";
import IndicadorChartBar from "./charts/IndicadorChartBar";
import IndicadorChartLine from "./charts/IndicadorChartLine";
import IndicadorChartPie from "./charts/IndicadorChartPie";
import { isMetaAtingida } from "./IndicadorUtil";

const indicadorDashboardService = new IndicadorDashboardService();
const indicadorService = new IndicadorService();
export default function IndicadorDashboardPage() {
    const [dadosDashboard, setDadosDashboard] = useState<IndicadorDashboard>(new IndicadorDashboard());
    const [dataFilter, setDataFilter] = useState<{ inicio: Date | null, fim: Date | null }>({
        inicio: null,
        fim: null
    });
    const { startLoading, stopLoading } = useLoadingContext();

    useEffect(() => {
        if (!dataFilter.inicio && !dataFilter.fim) {
            load();
        }
    }, [dataFilter])

    function load() {
        const idIndicador = Number(window.location.pathname.substring(`/indicador/dashboard/`.length));
        startLoading();
        indicadorDashboardService.dados(idIndicador, dataFilter).then((res) => {
            stopLoading();
            setDadosDashboard(res);
        }).catch((err) => {
            stopLoading();
            console.error(err);
        });
    }

    const [opcaoSelecionada, setOpcaoSelecionada] = useState<string>("barra");

    const opcoes = [
        { label: "", value: "barra", icon: "chart-simple", color: "#555" },
        { label: "", value: "linha", icon: "chart-line", color: "#555" },
        { label: "", value: "pizza", icon: "chart-pie", color: "#555" },
        { label: "", value: "tabela", icon: "table", color: "#555" },
    ]

    const formatarDataColeta = (coleta: IndicadorColeta) => {
        if (coleta.dataColeta == null) return "";
        if (coleta.indicador?.periodicidadeColeta?.tipoPeriodo == "MES") {
            return new Date(coleta.dataColeta).toLocaleDateString("pt-BR", { year: "numeric", month: "2-digit" });
        } else if (coleta.indicador?.periodicidadeColeta?.tipoPeriodo == "ANO") {
            return new Date(coleta.dataColeta).getFullYear().toString();
        } else {
            return converterData(coleta.dataColeta)
        }
    }


    return (
        <div>
            <div>
                <Label style={{ fontSize: 20, fontWeight: 700 }}>Indicador: </Label>
                <span style={{ fontSize: 20 }}> {dadosDashboard.nome}</span>
            </div>
            <div>
                <Label>Processo: </Label>
                <span> {dadosDashboard.processo?.nome}</span>
            </div>

            <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>

                <DatePicker
                    slotProps={{
                        popper: {
                            disablePortal: true,
                        },
                    }}
                    value={dataFilter?.inicio ? dayjs(dataFilter.inicio) : null}
                    onChange={value => {
                        if (value?.toDate())
                            setDataFilter({ ...dataFilter, inicio: value?.toDate() })
                    }}
                />
                <label style={{ marginLeft: 8, marginRight: 8 }}>à</label>
                <DatePicker
                    value={dataFilter?.fim ? dayjs(dataFilter.fim) : null}
                    onChange={value => {
                        if (value?.toDate())
                            setDataFilter({ ...dataFilter, fim: value?.toDate() })
                    }}
                />
                <Button label="Filtrar" icon="pi pi-filter" className="p-button-outlined" onClick={() => load()} style={{ marginLeft: 8 }} />
                <Button type="button" icon="pi pi-filter-slash" className="p-button-danger" label="Limpar" outlined onClick={() => setDataFilter({ inicio: null, fim: null })} style={{ marginLeft: 8 }} />
            </div>
            <div style={{ width: 200, marginBottom: 5 }}>

                <MultiSeletor
                    onChange={(value: string) => { setOpcaoSelecionada(value) }}
                    value={opcaoSelecionada}
                    width={200}
                    itemWidth={50}
                    options={opcoes}
                    iconSize="2x"
                    bgColor="#FFF"
                />
            </div>
            {opcaoSelecionada === "barra" && dadosDashboard.itens.length > 0 && <IndicadorChartBar dados={dadosDashboard.itens} unidadeMedida={dadosDashboard.unidadeMedida} />}
            {opcaoSelecionada === "linha" && dadosDashboard.itens.length > 0 && <IndicadorChartLine dados={dadosDashboard.itens} unidadeMedida={dadosDashboard.unidadeMedida} />}
            {opcaoSelecionada === "pizza" && dadosDashboard.itens.length > 0 && <IndicadorChartPie dados={dadosDashboard.itens} unidadeMedida={dadosDashboard.unidadeMedida} />}
            {
                opcaoSelecionada === "tabela" && dadosDashboard.itens.length > 0 && <DataTable value={dadosDashboard.itens} emptyMessage="Nenhum registro encontrado">
                    <Column field="coleta.dataColeta" header="Data Coleta" body={(rowData) => formatarDataColeta(rowData.coleta)}></Column>
                    <Column field="coleta.valorColeta" header="Resultado" body={(rowData) => indicadorService.getValorConvertido(rowData.coleta.indicador.unidadeMedida, rowData.coleta.valorColeta)} style={{ fontWeight: 700 }}></Column>
                    <Column field="meta.meta" header="Meta" body={(rowData: IndicadorDashboardItem) => {
                        if (rowData?.meta?.meta == null) return "-";
                        return indicadorService.getTipoMeta(rowData?.meta?.tipo || "").simbolo + " " + rowData?.meta?.meta || 0
                    }}></Column>
                    <Column field="coleta.usuarioColeta.nome" header="Responsável"></Column>
                    <Column body={(rowData: IndicadorDashboardItem) => {
                        const metaAtingida = isMetaAtingida(rowData?.coleta?.valorColeta || 0, rowData?.meta?.meta || 0, rowData?.meta?.tipo || "");
                        return <Tag severity={metaAtingida ? "success" : "danger"} value={metaAtingida ? "Meta atingida" : "Meta não atingida"} />
                    }}></Column>
                </DataTable>
            }

        </div >
    );
}